import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../../supabase';
import Star from '../star';

// Pass 'token' and 'invite' as props from ReviewPage
export default function AuthForm({ token, invite }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  // 1:1 STATE NAMES (Matching GuestForm)
  const [actualRating, setStars] = useState(5);
  const [content, SetContent] = useState(''); 
  const [text, setText] = useState('');

      const todayObj = new Date();
    const todayStr = todayObj.toISOString().split('T')[0]; 
    
    // 2. Get 1 Year Ago
    const yearAgoObj = new Date();
    yearAgoObj.setFullYear(todayObj.getFullYear() - 1);
    const yearAgoStr = yearAgoObj.toISOString().split('T')[0];

    const [dateOfExperience, setDateOfExperience] = useState(todayStr);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // 1. GET THE SESSION & USER
      const { data: { session } } = await supabase.auth.getSession();
      const user = session?.user; // Access the user object from the session

      if (!user) throw new Error("You must be logged in to post a verified review.");

      // 2. CONSTRUCT AUTHOR NAME FROM ACCOUNT METADATA
      // We prioritize the account name, fallback to the invite name if metadata is empty
      const accountName = `${user.user_metadata?.name || ''} ${user.user_metadata?.lastname || ''}`.trim();
      const finalAuthor = accountName || invite.customer_name;

      // 3. CALL EDGE FUNCTION
      const { data, error } = await supabase.functions.invoke('submit-verified-review', {
        body: {
          token: token,
          reviewData: {
            stars: actualRating,
            title: content,
            text: text,
            author: finalAuthor,
            date: dateOfExperience,
            user_id: user.id
             // This is now the actual platform name
          }
        },
        headers: {
          Authorization: `Bearer ${session?.access_token}`
        }
      });

      if (error || data?.success === false) throw new Error(data?.message || "Submission failed");

      // 4. THE CLEANUP
      sessionStorage.removeItem('pending_review_token');
      sessionStorage.removeItem('review_type');

      navigate(`/company/${invite.businesses.www}`);

    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getWindowStarColor = (starIndex) => {
    if (starIndex <= actualRating) {
    switch (actualRating) {
      case 5: return 'bg-five'; 
      case 4: return 'bg-four';
      case 3: return 'bg-three';
      case 2: return 'bg-two';
      case 1: return 'bg-one';
      default: return 'bg-[#E4E4E4] opacity-40';
    }
    }
    // Otherwise, use the default gray color.
    return 'bg-[#E4E4E4] opacity-40';
};


  return (
    <div className='flex flex-col xs:max-w-[700px] xs:rounded-[6px] xs:border xs:border-[#F2F2F2] xs:mt-[95px] xs:mx-auto w-full h-auto bg-white absolute z-20 xs:p-[32px] p-[16px]'>
      
      {/* IDENTIFICATION BADGE: Shows they are logged in */}

      <form onSubmit={handleSubmit}>
        {/* STAR RATING - 1:1 with Guest */}
        <div className='flex flex-row justify-between items-center'>
            <div className='flex gap-[4.7px] xs:gap-[5.7px]'>
                {[1, 2, 3, 4, 5].map((index) => (
                    <div key={`win-star-${index}`} onClick={() => setStars(index)} className="cursor-pointer">
                        <Star 
                            bgColor={getWindowStarColor(index)} 
                            boxheight={'h-[32px] xs:h-[55px]'} 
                            boxwidth={'w-[32px] xs:w-[55px]'} 
                            width={'w-[18px] xs:w-[30px]'}
                        />
                    </div>
                ))}
            </div>
        </div>

        <div className='flex flex-col gap-[24px] xs:gap-[32px] mt-[24px] xs:mt-[32px]'>
            {/* TITLE */}
            <div className='flex flex-col gap-[10px]'>
                <label className='font-noto font-regular text-[#1a1a1a] text-[16px]'>Review Title</label>
                <input 
                    type="text" 
                    value={content}
                    onChange={(e) => SetContent(e.target.value)}
                    placeholder="Quick and trustworthy"
                    className='w-full min-h-[45px] outline-none border border-[#F6F6F6] rounded-[4px] p-3' 
                    required
                />
            </div>
                
            {/* REVIEW TEXT */}
            <div className='flex flex-col gap-[10px]'>
                <label className='font-noto font-regular text-[#1a1a1a] text-[16px]'>Tell us more about your experience</label>
                <textarea 
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder="Explain your experience..."
                    className='w-full min-h-[105px] border outline-none border-[#F6F6F6] rounded-[4px] p-3' 
                    rows={4}
                    required
                />
            </div>

                <div className='flex flex-col gap-[10px]'>
                        <label htmlFor="date" className='font-noto font-regular text-[#1a1a1a] text-[16px]'>Date of Experience</label>
                        <input 
                            type="date" 
                            value={dateOfExperience}
                            min={yearAgoStr} // Blocks everything older than 365 days
                            max={todayStr}   // Blocks the future
                            onChange={(e) => setDateOfExperience(e.target.value)}
                            className="w-full min-h-[45px] border border-[#F6F6F6] rounded-[4px] p-3"
                        />
                    </div>

            <div className='flex flex-col xs:flex-row xs:justify-between'>
         

                <button 
                    type="submit"
                    className='w-[256px] xs:mt-auto xs:mx-0 h-[50px] rounded-[5px] bg-[#56AB75] text-[18px] font-noto font-medium text-white mt-[32px] mx-auto block'
                    disabled={loading}
                >
                    {loading ? 'Processing...' : 'Post Verified Review'}
                </button>
            </div>
        </div>
      </form> 
    </div>
  );
}